<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-table font-dark"></i>
          <h3 class="box-title">Exportação de dados - Empresas</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <ParksFilter :parks="parks" :disabled="waitingDownload" />
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <h4>Filtrar Empresas <button class="btn btn-success" @click="alterLinked">{{defaultLinked}}</button> no ano de</h4>
                <div class="form-group">
                  <div class="center-inside-col">
                    <select v-model="selectedYear" class="form-control" :disabled="waitingDownload">
                      <option v-for="year in availableYears" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-block btn-success"
                @click="handleDownloadClick"
                :disabled="waitingDownload || selectedParksIds.length === 0"
              >
                Baixar arquivo em formato Excel &nbsp;
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParksFilter from './ParksFilter'
  import { BackendApi } from '@/services/backend_api'
  import { saveAs } from 'file-saver'

  const CURRENT_YEAR = (new Date()).getFullYear()

  export default {
    name: 'ExportCompanies',
    components: { Adminlte, ParksFilter },
    data: function () {
      return {
        parks: [],
        selectedYear: CURRENT_YEAR,
        waitingDownload: false,
        defaultLinked: 'ativas',
        linked: 1
      }
    },
    async mounted () {
      this.parks = await this.getParks()
    },
    methods: {
      async getParks () {
        const response = await BackendApi.getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0')
        const parksResponseWithNoLinksNeitherTotalElements = Object.values(response.data).slice(0, -2)
        return parksResponseWithNoLinksNeitherTotalElements.map((park) =>
          Object.assign({ isSelected: true }, park)
        )
      },
      handleDownloadClick (e) {
        e.preventDefault()

        const queryParams = {
          parks: this.selectedParksIds.join(','),
          year: this.selectedYear,
          linked: this.linked
        }

        this.waitingDownload = true
        BackendApi.getClient().get('/spreadsheet/companies', {
          params: queryParams, responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, 'companies.xlsx')
        }).finally(() => {
          this.waitingDownload = false
        })
      },
      alterLinked () {
        this.defaultLinked = this.defaultLinked === 'ativas' ? 'inativas' : 'ativas'
        this.linked = this.linked ? 0 : 1
      }
    },
    computed: {
      availableYears: function () {
        const firstAvailableYear = 1985

        let years = []
        for (let i = CURRENT_YEAR; i >= firstAvailableYear; i--) {
          years.push(i)
        }
        return years
      },
      selectedParksIds: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.id)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// ExportCompanies.vue?5de99283